<div class="modal-content">
  <div class="modal-header" *ngIf="config?.title">
    {{ config.title }}
  </div>
  <div class="modal-body">
    <div *ngIf="apiLoaded">
      <google-map #map [height]="'640px'" [options]="options" [width]="'100%'">
        <map-polygon *ngIf="config?.editing" [paths]="initCoords"
          [options]="polygonOptions">
        </map-polygon>
        <map-polygon *ngFor="let area of config?.readOnlyAreas"
          [options]="area.options"
          [paths]="area.coords">
        </map-polygon>
      </google-map>
    </div>
  </div>
  <div class="modal-footer">
    <span style="width: 100%;">&nbsp; &nbsp;
      Área: {{ areaSelecionada | number:'1.0-0' }} m²
      &nbsp; | &nbsp;
      {{ areaHa | number:'1.1-2' }} ha
    </span>
    <button type="button" class="btn btn-ligth"
      *ngIf="config?.readOnlyAreas?.length === 1 && !config?.editing"
      (click)="setActualArea($event)">{{ 'Seleção' }}
    </button>
    <button type="button" class="btn btn-success" (click)="ok($event)">{{ config?.okText || 'OK' }}</button>
    <button type="button" class="btn btn-secondary" (click)="cancel($event)">{{ config?.cancelText || 'Cancelar'
      }}</button>
  </div>
</div>
